import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ViewChild,
} from "@angular/core";
import {
  FlexLayoutModule,
  MediaObserver,
  MediaChange,
} from "@angular/flex-layout";
import { Observable, Subscriber, Subscription } from "rxjs";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import * as _ from "lodash";

import { ToastService } from "src/app/services/toast/toast.service";
import { TranslateService } from "@ngx-translate/core";
import { LoginService } from "src/app/services/login/login.service";

import { GetDatePipe } from "src/app/pipes/pipes/pipe-date.pipe";
import { ActivatedRoute } from "@angular/router";
import { IncidentsModalComponent } from "./modal/incidents-modal.component";
import { IncidentsService } from "src/app/services/incidents/incidents.service";
import { UserService } from "src/app/services/user/user.service";
import { AlarmaModel, InformaModel } from "./models/incidents-model";
import { UserModel } from "src/app/models/userModel";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { MatSort, MatSortable } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-incidents",
  templateUrl: "./incidents.component.html",
  styleUrls: ["./incidents.component.scss"],
  providers: [GetDatePipe],
})
export class IncidentsComponent implements OnInit {
  activatedStyle = false;
  isSelected = false;
  enableAlarmasDetail = false;
  enableAlarmasForm = false;
  alarmaSelected: AlarmaModel;
  elementData: AlarmaModel[] = [];
  elementDataAux: AlarmaModel[] = [];
  elementUserData: UserModel[] = [];
  elementUserDataAux: UserModel[] = [];
  formMode = "";
  isAdmin = false;
  loadingText = "LOADING.ALARMAS";
  showAlarmas = false;
  loading = false;

  mobileMode: boolean = false;
  private mediaSub: Subscription;
  userId: string;
  filter = "";
  currentAlarm: string;
  lastAlarmArray = [];

  displayedColumnsListAlarms: string[];
  dataSourceListAlarms: any;
  displayedColumnsTypesAlarms: string[];
  dataSourceTypesAlarms: any;
  displayedColumnsLastAlarms: string[];
  dataSourceLastAlarms: any;
  users: any;
  alarmTypes: any;

  pie_data1 = {
    data: [],
    layout: {},
  };

  pie_data2 = {
    data: [],
    layout: {},
  };

  pie_x1 = [];
  pie_y1 = [];

  pie_x2 = [];
  pie_y2 = [];

  incidentOcurrences: number = 0;
  arrayIncidentOcurrences: number[] = [];
  arrayIncidentOcurrencesTd: number[] = [];
  arrayIncidentOcurrencesDisp: number[] = [];

  // Collection MongoDB
  collectionCampaigns = "campaigns";
  collectionConsumptions = "consumptions";
  collectionNameIntervalsTundish = "9a72b49a-82ff-4406-89c8-b8e21d5ddc11";
  collectionNameSubintervalsTundish = "f05ec735-1752-4926-9cda-aa546fa2add7";
  collectionNameIntervalsGunning = "cf9d103e-ce1a-4696-b29e-c26348c2b11e";

  @ViewChild("alarmsTable", { static: true }) table: MatTable<any>;
  @ViewChild("paginator1", { static: true }) paginator1: MatPaginator;
  @ViewChild("paginator2", { static: true }) paginator2: MatPaginator;
  @ViewChild("paginator3", { static: true }) paginator3: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort3: MatSort;

  // Row remarking table
  highlightedRows = [];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private mediaObserver: MediaObserver,
    private fb: FormBuilder,
    private toastr: ToastService,
    private translate: TranslateService,
    private loginService: LoginService,
    private incidentsService: IncidentsService,
    private userService: UserService,
    private dialog: MatDialog,
    private getDatePipe: GetDatePipe,
    private route: ActivatedRoute
  ) {
    this.isAdminUser();
  }

  isAdminUser() {
    if (this.loginService.currentUserValue.rol.includes("admin")) {
      this.isAdmin = true;
    }
  }

  ngOnInit() {
    this.filter = this.route.snapshot.paramMap.get("filter");

    this.mediaSub = this.mediaObserver.media$.subscribe(
      (change: MediaChange) => {
        if (change.mqAlias == "xs" || change.mqAlias == "sm") {
          this.mobileMode = true;
        } else {
          this.mobileMode = false;
        }
      }
    );

    this.userId = this.loginService.currentUserValue.uuid;
    this.isAdminUser();

    this.displayedColumnsTypesAlarms = [
      "uuid",
      "nombre",
      "cantidad",
      "notificar",
      "dispositivo",
      "visualizar",
      "acciones",
    ];
    this.displayedColumnsListAlarms = [
      "uuid",
      "dispositivo",
      "alarma",
      "campaña",
      "timestamp",
    ];
    this.displayedColumnsLastAlarms = [
      "uuid",
      "dispositivo",
      "alarma",
      "fecha",
    ];

    this.doRetrieveAlarms();
  }

  ngAfterInit() {
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.mediaSub.unsubscribe();
  }

  public doFilter = (option: number, event) => {
    let { value } = event.target;
    if (option == 1)
      this.dataSourceListAlarms.filter = value.trim().toLocaleLowerCase();
    else this.dataSourceTypesAlarms.filter = value.trim().toLocaleLowerCase();
  };

  doRetrieveAlarms() {
    this.incidentsService.getTiposIncidente().subscribe(
      (data) => {
        console.log(data);
        let objects = [];
        let results = data.data.findTipoDatoEstados;
        for (let i = 0; i < results.length; i++) {
          for (let j = 0; j < results[i].tipoDatoEstado.length; j++) {
            if (results[i].tipoDatoEstado[j].nombre.includes("FALLO")) {
              const result = { ...results[i].tipoDatoEstado[j] };
              result.dispositivo = results[i].nombre;
              result.dispositivoUuid = results[i].uuid;
              result.ocurrencias = 0;
              objects.push(result);
            }
          }
        }
        this.doPlotSummaryChart(objects);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doRetrieveAlarmsByType(disp, td, name) {
    console.log("doRetrieveAlarmsByType DISP ->", disp);
    console.log("doRetrieveAlarmsByType TD ->", td);
    console.log("doRetrieveAlarmsByType NAME ->", name);
    let collection = "";
    this.incidentsService.getDispositivoFromUuid(disp).subscribe(
      (data) => {
        let dispName = data.data.getDispositivo.nombre;
        console.log(dispName);
        if (dispName == "Gunitadora")
          collection = this.collectionNameIntervalsGunning;
        else collection = this.collectionNameIntervalsTundish;
        this.incidentsService.getIncidentOccurrences(disp, td).subscribe(
          (data) => {
            let occurrences = [];
            let timeserie = [...data.data.findTimeSerie];
            for (let i = 0; i < timeserie.length; i++) {
              timeserie[i] = { ...timeserie[i] };
              timeserie[i].uuid = td;
              timeserie[i].alarma = name;
              if (timeserie[i].valor == 1) {
                occurrences.push(timeserie[i]);
              }
            }
            for (let i = 0; i < occurrences.length; i++) {
              let fecha = occurrences[i].fecha;
              fecha = fecha / 1000000000;
              console.log("Collection -> ", collection);
              this.incidentsService
                .getIntervalsForGivenDate(collection, fecha)
                .subscribe(
                  (data) => {
                    console.log("getIntervalsForGivenDate -> ", data);
                    let intervals = data.data.findIntervalsForGivenDate;
                    console.log("Intervals -> ", intervals);
                    for (let j = 0; j < intervals.length; j++) {
                      this.incidentsService
                        .getDispositivoFromUuid(intervals[j].disp)
                        .subscribe(
                          (data) => {
                            console.log("getDispositivoFromUuid -> ", data);
                            intervals[j].dispNombre =
                              data.data.getDispositivo.nombre;
                            this.incidentsService
                              .getCampaignByDateAndDisp(
                                this.collectionCampaigns,
                                fecha,
                                intervals[j].disp
                              )
                              .subscribe(
                                (data) => {
                                  console.log(
                                    "getCampaignByDateAndDisp -> ",
                                    data
                                  );
                                  intervals[j].nombre =
                                    data.data.findCampaignByDateAndDisp[0].nombre;
                                },
                                (err) => {
                                  console.log(err);
                                }
                              );
                          },
                          (err) => {
                            console.log(err);
                          }
                        );
                    }
                    occurrences[i].campaign = intervals;
                    console.log(occurrences[i].campaign);
                  },
                  (err) => {
                    console.log(err);
                  }
                );
            }
            this.dataSourceListAlarms = new MatTableDataSource(occurrences);
            this.paginator2.pageSize = 5;
            this.paginator2.pageIndex = 0;
            this.paginator2.length = occurrences.length;
            this.dataSourceListAlarms.paginator = this.paginator2;
          },
          (err) => {
            console.log(err);
          }
        );
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doRetrieveAlarmTypesAndUsers(id, option) {
    this.incidentsService.getTiposAlarma().subscribe(
      (data) => {
        this.alarmTypes = data.findTipoAlarmas;
        this.userService.getUserCollectionReal().subscribe(
          (data) => {
            // Filtramos por los usuarios de dominion
            for (let i = 0; i < data.length; i++) {
              if (data[i].email.includes("dominion"))
                this.elementUserData.push(data[i]);
            }
          },
          (err) => {
            console.log(err);
          }
        );
        this.dialog.open(IncidentsModalComponent, {
          width: "25%",
          data: {
            title: "Alarma: Añadir",
            id: id,
            content: "",
            option: option,
            users: this.elementUserData,
            types: this.alarmTypes,
          },
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doRetrieveUserNotificationListByAlarm(id, option) {
    this.users = [];
    this.alarmTypes = [];
    this.incidentsService.getAlarmsFromJSONFile().subscribe(
      (data) => {
        for (let i = 0; i < data.data.listadoAlarmas.length; i++) {
          if (data.data.listadoAlarmas[i].uuid == id) {
            this.users = data.data.listadoAlarmas[i].informa;
          }
        }
        this.dialog.open(IncidentsModalComponent, {
          width: "50%",
          data: {
            title: "Alarma: Listado de Usuarios a ser notificados...",
            id: id,
            content: "",
            option: option,
            users: this.users,
          },
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doLoadAlarmsTable(data) {
    this.dataSourceTypesAlarms = new MatTableDataSource(data);
    this.paginator1.pageSize = 5;
    this.paginator1.pageIndex = 0;
    this.paginator1.length = data.length;
    this.dataSourceTypesAlarms.paginator = this.paginator1;
  }

  doLoadLastAlarmsTable(data) {
    console.log("doLoadLastAlarmsTable -> ", data);
    this.dataSourceLastAlarms = new MatTableDataSource(data);
    this.paginator3.pageSize = 5;
    this.paginator3.pageIndex = 0;
    this.paginator3.length = data.length;
    this.dataSourceLastAlarms.paginator = this.paginator3;
    this.sort3.sort(<MatSortable>{ id: "fecha", start: "desc" });
    this.dataSourceLastAlarms.sort = this.sort3;
  }

  doPlotSummaryChart(data) {
    console.log("doPlotSummaryChart -> ", data);
    for (let i = 0; i < data.length; i++) {
      this.doObtainOcurrencesByIncident(
        data[i].dispositivoUuid,
        data[i].dispositivo,
        data[i].uuid,
        data[i].nombre
      );
    }
    // We need to setTimeout in order to populate charts and table
    setTimeout(() => {
      console.log(this.pie_x1);
      console.log(this.pie_y1);
      console.log(this.pie_x2);
      console.log(this.pie_y2);
      this.pie_data1.data.push({
        values: this.pie_x1,
        labels: this.pie_y1,
        hoverinfo: "label+percent",
        hole: 0.4,
        type: "pie",
      });
      this.pie_data1.layout = { title: "Gunitadora", autosize: true };
      this.pie_data2.data.push({
        values: this.pie_x2,
        labels: this.pie_y2,
        hoverinfo: "label+percent",
        hole: 0.4,
        type: "pie",
      });
      this.pie_data2.layout = { title: "Coldmag", autosize: true };
      // We need to set the occurrences of incidents
      for (let i = 0; i < data.length; i++) {
        if (data[i].dispositivo == "Gunitadora") {
          for (let j = 0; j < this.pie_y1.length; j++) {
            if (this.pie_y1[j] == data[i].nombre)
              data[i].ocurrencias = this.pie_x1[j];
          }
        } else {
          for (let j = 0; j < this.pie_y2.length; j++) {
            if (this.pie_y2[j] == data[i].nombre)
              data[i].ocurrencias = this.pie_x2[j];
          }
        }
      }
      this.doLoadAlarmsTable(data);
      this.doLoadLastAlarmsTable(this.lastAlarmArray);
    }, 10000);
  }

  doOpenDialog(id, option, disp, name) {
    switch (option) {
      case -1:
        if (id != -1) {
          this.dialog.open(IncidentsModalComponent, {
            width: "25%",
            data: {
              title:
                "Cargando información de la Alarma con UUID " +
                id +
                " y nombre " +
                name,
              id: id,
              content: "Cargando información...",
              option: option,
              wait: true,
            },
          });
          setTimeout(() => {
            this.dialog.closeAll();
            this.doRetrieveAlarmsByType(disp, id, name);
            this.currentAlarm = id;
          }, 3000);
        } else {
          // Open dialog to add alarm with users and alarm types precharged
          this.doRetrieveAlarmTypesAndUsers(id, option);
        }
        break;
      case -2:
        //
        this.doRetrieveUserNotificationListByAlarm(id, option);
        break;
      case 0:
        this.dialog.open(IncidentsModalComponent, {
          data: {
            width: "25%",
            title: "Alarma: Editar",
            id: id,
            content: "",
            option: option,
          },
        });
        break;
      case 1:
        this.dialog.open(IncidentsModalComponent, {
          data: {
            width: "25%",
            title: "Alarma: Eliminar",
            id: id,
            content: "",
            option: option,
          },
        });
        break;
      case 2:
        this.dialog.open(IncidentsModalComponent, {
          data: {
            width: "25%",
            title: "Alarma: Rearmar",
            id: id,
            content: "",
            option: option,
          },
        });
        break;
    }
  }

  doObtainOcurrencesByIncident(
    dispositivoUuid: any,
    dispositivoNombre,
    tdUuuid: any,
    tdNombre
  ) {
    this.incidentsService
      .getIncidentOccurrences(dispositivoUuid, tdUuuid)
      .subscribe(
        (data) => {
          console.log("Dispositivo UUID -> ", dispositivoUuid);
          console.log("TD UUID -> ", tdUuuid);
          console.log(data);
          let dateFrom = Date.now() - 604800000; // Cogemos de referencia la ultima semana para rellenar la tabla de Ultimas Indicencias
          let counter = 0;
          let timeserie = data.data.findTimeSerie;
          for (let i = 0; i < timeserie.length; i++) {
            if (timeserie[i].valor == 1) {
              counter++;
              if (timeserie[i].fecha >= dateFrom * 1000000) {
                this.lastAlarmArray.push({
                  dispositivo: dispositivoNombre,
                  nombre: tdNombre,
                  uuid: tdUuuid,
                  fecha: timeserie[i].fecha,
                });
              }
            }
          }
          this.arrayIncidentOcurrences.push(counter);
          // Add this to plot array
          if (dispositivoNombre == "Gunitadora" && counter != 0) {
            this.pie_x1.push(counter);
            this.pie_y1.push(tdNombre);
          } else if (dispositivoNombre == "ColdMag" && counter != 0) {
            this.pie_x2.push(counter);
            this.pie_y2.push(tdNombre);
          }
          console.log("Ocurrences -> ", counter);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  doTransformDate(stringDate) {
    if (stringDate != null && stringDate != "") {
      let d = new Date(stringDate);
      return d.toLocaleString();
    }
  }

  doHighlight(row) {
    console.log("Highlighting row -> ", row);
    this.highlightedRows = [];
    this.highlightedRows.push(row);
  }
}
